var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#FFE5E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3635_25129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 67,
    height: 67
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 66.2069,
    height: 66.2069,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3635_25129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5168 72.931C22.0111 72.931 21.5513 72.8046 21.1375 72.5517C20.7237 72.2989 20.4019 71.9655 20.172 71.5517C19.9421 71.1379 19.8157 70.6897 19.7927 70.2069C19.7697 69.7241 19.8961 69.2529 20.172 68.7931L45.6892 24.6552C45.9651 24.1954 46.3214 23.8506 46.7582 23.6207C47.195 23.3908 47.6433 23.2759 48.103 23.2759C48.5628 23.2759 49.0111 23.3908 49.4479 23.6207C49.8846 23.8506 50.241 24.1954 50.5168 24.6552L76.0341 68.7931C76.3099 69.2529 76.4364 69.7241 76.4134 70.2069C76.3904 70.6897 76.264 71.1379 76.0341 71.5517C75.8042 71.9655 75.4823 72.2989 75.0686 72.5517C74.6548 72.8046 74.195 72.931 73.6892 72.931H22.5168ZM27.2754 67.4138H68.9306L48.103 31.5517L27.2754 67.4138ZM48.103 64.6552C48.8846 64.6552 49.5398 64.3908 50.0686 63.8621C50.5973 63.3333 50.8617 62.6782 50.8617 61.8966C50.8617 61.1149 50.5973 60.4598 50.0686 59.931C49.5398 59.4023 48.8846 59.1379 48.103 59.1379C47.3214 59.1379 46.6663 59.4023 46.1375 59.931C45.6088 60.4598 45.3444 61.1149 45.3444 61.8966C45.3444 62.6782 45.6088 63.3333 46.1375 63.8621C46.6663 64.3908 47.3214 64.6552 48.103 64.6552ZM48.103 56.3793C48.8846 56.3793 49.5398 56.1149 50.0686 55.5862C50.5973 55.0575 50.8617 54.4023 50.8617 53.6207V45.3448C50.8617 44.5632 50.5973 43.908 50.0686 43.3793C49.5398 42.8506 48.8846 42.5862 48.103 42.5862C47.3214 42.5862 46.6663 42.8506 46.1375 43.3793C45.6088 43.908 45.3444 44.5632 45.3444 45.3448V53.6207C45.3444 54.4023 45.6088 55.0575 46.1375 55.5862C46.6663 56.1149 47.3214 56.3793 48.103 56.3793Z",
    fill: "#E10505"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.fab629af57b08983553b598deebe4fd5.svg";
export { ForwardRef as ReactComponent };